<template>
  <VoteBase>
    <template v-slot:voteMain>
      <div class="animated fadeIn">
        <b-card>
          <div slot="header">
            <b-button :to="{name: 'vote-list', params: {oversea: !!JSON.parse($route.query.oversea)}}" size="sm" variant="link"><i class="fa fa-chevron-left" /></b-button>
            配置投票项{{ appName ? '【' + appName + '】' : '' }}{{ !!JSON.parse($route.query.oversea) ? overseaTag : '' }}
          </div>
          <b-link :to="{name: 'vote-item-create', params: {appId: appId}, query: {oversea: !!JSON.parse($route.query.oversea)}}">
            <b-button variant="outline-primary" :style="{marginBottom: '18px'}" >
              创建投票项
            </b-button>
          </b-link>
          <b-button variant="outline-success" @click="pull" :style="{marginBottom: '18px'}" >
            拉取投票项
          </b-button>
          <b-table v-if="fields" class="text-center" show-empty responsive="sm" :busy="items === null" :items="items" :fields="fields" :current-page="currentPage" :emptyText="tableEmptyText" >
            <template #cell(online)="data">
              <b-form-checkbox switch v-model="data.item.online" @click.native="changeOnline(data.item.vote_id, data.item.online)" required />
            </template>

            <template #cell(item_op)="data">
              <b-link :to="{name: 'vote-item-update', params: {appId: appId, itemId: data.item.vote_id}, query: {oversea: !!JSON.parse($route.query.oversea)}}">
                <b-button size="sm" variant="outline-warning">
                  <i class="fa fa-edit" /> 编辑
                </b-button>
              </b-link>
              <b-button size="sm" variant="outline-primary" @click="modifyVoteItemVotes(appId, data.item.vote_id, data.item.vote)">
                <i class="fa fa-edit" /> 修改票数
              </b-button>
            </template>

            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle" />
                <strong>加载中...</strong>
              </div>
            </template>
          </b-table>
          <nav v-if="fields">
            <b-pagination
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="<<"
              next-text=">>"
              @change="changePage"
              hide-goto-end-buttons
              first-number
              last-number
            />
          </nav>
        </b-card>
        <VoteItemVotesModify ref="modifyVote" @finish="modifyFinish" />
      </div>
    </template>
  </VoteBase>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import consts from '@/utils/consts'
import VoteBase from './Base'
import VoteItemVotesModify from '@/components/Vote/VoteItemVotesModify'

export default {
  name: 'vote-item',
  mixins: [Error],
  components: {VoteBase, VoteItemVotesModify},
  data () {
    return {
      data: null,
      items: null,
      fields: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      appId: this.$route.params.appId,
      limitConfigFields: consts.VOTE_ITEM_LIMIT_CONFIG_FIELDS,
      collapse_prefix: 'limit-config-collapse',
      tableEmptyText: consts.TABLE_EMPTY_TEXT,
      appName: '',
      firstSave: true,
      overseaTag: consts.overseaTag
    }
  },
  created () {
    if (this.firstSave && this.$route.params.save) {
      this.totalRows = sessionStorage.getItem('voteItemRow')
      this.currentPage = sessionStorage.getItem('voteItemPage')
      this.firstSave = false
    }
    this.getData()
  },
  beforeDestroy () {
    sessionStorage.setItem('voteItemPage', this.currentPage)
    sessionStorage.setItem('voteItemRow', this.totalRows)
  },
  methods: {
    getData () {
      api.voteHandler(this, api.getVoteDetail(), 'GET', {app_id: this.$route.params.appId}, JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : '', this.getAppName)
      api.detailVoteData(this, api.getVoteDetail(), 'GET', 'data', {app_id: this.$route.params.appId}, JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : '', this.getFieldsAndItems)
    },
    changePage (page) {
      let params = {
        app_id: this.$route.params.appId
      }
      this.currentPage = page
      api.fetchVoteListData(this, api.getVoteItemList(), 'vote_list', params, JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : '', this.handleData)
    },
    getAppName (res) {
      this.appName = res.data.app_name
    },
    getFieldsAndItems () {
      // get fields
      let staticFields = [...consts.VOTE_ITEM_STATIC_FIELDS_1.map(i => Object.keys(i)[0]), ...consts.VOTE_ITEM_STATIC_FIELDS_2.map(i => Object.keys(i)[0])]
      let fields = []
      let tableConfig = this.data.table_config
      for (let key in tableConfig) {
        if (key.indexOf('list') !== -1) {
          for (let idx in tableConfig[key].fields) {
            if (staticFields.indexOf(tableConfig[key].fields[idx].field) === -1 && tableConfig[key].fields[idx].field !== 'limit_config') {
              let tmpDict = {}
              tmpDict[tableConfig[key].fields[idx].field] = tableConfig[key].fields[idx].field
              fields.push(tmpDict)
            }
          }
          break
        }
      }
      this.fields = [...consts.VOTE_ITEM_STATIC_FIELDS_1, ...fields, ...consts.VOTE_ITEM_STATIC_FIELDS_2]
      // get items
      let params = {
        app_id: this.$route.params.appId
      }
      api.fetchVoteListData(this, api.getVoteItemList(), 'vote_list', params, JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : '', this.handleData)
    },
    handleData (resData) {
      for (let idx in resData['vote_list']) {
        resData['vote_list'][idx].online = !!resData['vote_list'][idx].online
        resData['vote_list'][idx].collapse_id = this.collapse_prefix + idx.toString()
        if (resData['vote_list'][idx].limit_config) {
          if (!resData['vote_list'][idx].limit_config.every && resData['vote_list'][idx].limit_config.every !== 0) {} else {
            resData['vote_list'][idx].limit_config.islimit = !!resData['vote_list'][idx].limit_config.islimit
            resData['vote_list'][idx].limit_config.every = consts.LIMIT_CONFIG_TEXT[resData['vote_list'][idx].limit_config.every.toString()]
            let stList = resData['vote_list'][idx].limit_config.limit_start_time.split('-')
            let etList = resData['vote_list'][idx].limit_config.limit_end_time.split('-')
            resData['vote_list'][idx].limit_config.limit_start_time = stList.slice(0, 3).join('-') + ' ' + stList.slice(3).join(':')
            resData['vote_list'][idx].limit_config.limit_end_time = etList.slice(0, 3).join('-') + ' ' + etList.slice(3).join(':')
          }
        }
      }
      this.items = resData['vote_list']
      this.totalRows = resData.total_num
    },
    offlineItem (id) {
      let data = {
        app_id: this.$route.params.appId,
        vote_id: id
      }
      api.updateVoteData(this, api.getVoteItemOffline(), 'POST', data, JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : '', this.getData)
    },
    onlineItem (id) {
      let data = {
        app_id: this.$route.params.appId,
        vote_id: id
      }
      api.updateVoteData(this, api.getVoteItemOnline(), 'POST', data, JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : '', this.getData)
    },
    changeOnline (id, isOnline) {
      if (isOnline) {
        this.offlineItem(id)
      } else {
        this.onlineItem(id)
      }
    },
    pull () {
      let params = { app_id: this.$route.params.appId }
      api.voteHandler(this, api.getVoteItemPull(), 'GET', params, JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : '', this.pullCallback)
    },
    pullCallback (res) {
      if (res.success) {
        this.$message.success('拉取成功')
        this.changePage(this.currentPage)
      } else {
        this.$message.error('拉取失败，请检查拉取配置是否正确')
      }
    },
    updateConf () {
      let reqData = {
        path: api.getVoteItemConfUpdate(),
        type: JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : process.env.NODE_ENV.slice(0, 3),
        method: 'POST',
        data: { app_id: this.$route.params.appId }
      }
      return this.$ajax.post(api.getBaseUrl() + 'vote_project', reqData).then((res) => {
        if (res.success) {
          this.$message.info('同步成功')
          this.changePage(this.currentPage)
        } else {
          this.handleError(res)
        }
      }, (res) => {
        this.handleError(res)
      })
    },
    modifyVoteItemVotes (appId, voteId, curVote) {
      this.$refs.modifyVote.show({
        curVotes: curVote,
        appId: appId,
        voteId: voteId
      })
    },
    modifyFinish () {
      this.$refs.modifyVote.modalShow = false
      api.detailVoteData(this, api.getVoteDetail(), 'GET', 'data', {app_id: this.$route.params.appId}, JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : '', this.getFieldsAndItems)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// VoteItem.vue?4f6ab8f7